<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12">
            <label>Nombre Sucursal</label>
            <base-input v-model="Name" placeholder="Ejemplo: Sucursal 1"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-4">
            <label>Código Postal (CPA)</label>
            <postal-code-validator
              v-model="CodigoPostal"
              @cp-validated="updateCodigoPostalValidity"
            ></postal-code-validator>
            </div> 
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Provincia</label>
            <base-input v-model="ProvinceName" disabled></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Localidad</label>
            <KitsBusquedaSimple url="City/GetTopByText" v-model="City" :request="{ ProvinceID: this.ProvinceID }" :currentValue="City" :cleanButton="true" />
          </div> 
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Calle</label>
            <base-input v-model="Street" placeholder="Escribí la calle"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Numero</label>
            <base-input v-model="Num" placeholder="Escribí el número de dirección"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>N° de Local</label>
            <base-input v-model="Local" placeholder="Ejemplo: Local Número 25"></base-input>
          </div>
        </div>

        <div class="row" v-if="EntityID==0">
          <div class="col-md-12">
            <label>Agregar Caja</label>
            <div class="input-group mb-3">
              <input v-model="CajaName" type="text" class="form-control" />
              <div class="input-group-append">
                <button class="btn btn-warning" type="button" @click="addCaja()">
                  <i class="fa fa-plus fa-fw"></i>Agregar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row form-group right"></div>
        <div class="row form-group" v-if="EntityID==0">
          <div class="col-md-12">
            <div style="background-color: white; border-radius: 5px; border: #d6d4d4 1px solid">
              <div
                class="row"
                v-for="item in Cajas"
                v-bind:key="item.EntityID"
                :value="item.EntityID"
                style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
              >
                <div class="col-lg-6 col-md-12" style="display: flex">
                  <span
                    style="margin-left: 10px;margin-top: 10px; font-size:42px;"
                    class="fa fa-fw fa-cash-register"
                  />
                  <div style="margin-left: 10px;margin-top: 22px; margin-bottom:22px;">
                    <div>{{item.Name}}</div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-12" style="margin-top: 22px; max-width: 200px;">
                  <button
                    type="button"
                    @click="itemClicked(item)"
                    class="btn btn-danger btn-block"
                    style="border-bottom:10px;"
                  >
                    <i class="fa fa-cash-trash fa-fw"></i>Quitar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <button @click="goBack" class="btn btn-danger btn-lg">Volver</button>
            <save-button @click="addUpdate"></save-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import KitsBusquedaSimple from "@/components/KitsBusquedaSimple";
import PostalCodeValidator from "@/components/Custom/PostalCodeValidator";

export default {
  name: "crearsucursal",
  props: {
    title: String,
    EntityIDProp: Number
  },
  directives: {},
  components: { KitsBusquedaSimple, PostalCodeValidator },

  data() {
    return {
      EntityID: this.EntityIDProp,
      Name: "",
      CodigoPostal: "",
      CodigoPostalIsValid: false,
      OriginalProvinceZipCodeID: null, // -- Valor cuando se levanta el formulario. Se asigna aqui por error en seteo de ProvinceZipCodeID
      SeModificaCP: false,
      ProvinceZipCodeID: null,
      ProvinceID: null,
      ProvinceName: "",
      UpdateProvinceName: true,
      City: null,
      Street: "",
      Num: "",
      Local: "",
      Cajas: [],
      CajaName: "",
      FromGetData: false
    };
  },
  methods: {
    updateCodigoPostalValidity(response) {
      this.CodigoPostalIsValid = response.isValid;
      //if(this.FromGetData == false){
      this.ProvinceZipCodeID=response.provinceZipCode.id;
      this.ProvinceID=response.provinceZipCode.provinceID;
      //}
      //this.FromGetData = false;
      if(this.UpdateProvinceName){
      this.ProvinceName=response.provinceZipCode.provinceName;
      }
      this.UpdateProvinceName=true;
    },

    validateProvince(){
      let context = this;
      if(context.ProvinceID == null){
        context.City = null;
        notificationHelpers.showError(
          "Alerta!",
          "Debe seleccionar una provincia",
          context
        );
        context.UpdateProvinceName = true;
        return;
      }
    },

    isUpdate() {
      return this.EntityID > 0;
    },

    goBack() {
      this.$router.push("sucursales");
    },

    getData() {
      let context = this;
      context.UpdateProvinceName = false;
        axiosHelpers.axiosPost(
          "Commerce/GetBranchOfficeInfo",
          { BranchOfficeID: context.EntityID },
          this,
          function(data) {
            //context.FromGetData = true;
            context.Name = data.ResponseVM.Name;
            context.OriginalProvinceZipCodeID = data.ResponseVM.ProvinceZipCodeID;
            context.ProvinceZipCodeID = data.ResponseVM.ProvinceZipCodeID;
            context.ProvinceID = data.ResponseVM.ProvinceID;
            context.ProvinceName = data.ResponseVM.ProvinceName;
            context.CodigoPostal = data.ResponseVM.PostalCode;
            context.City = {
              ID: data.ResponseVM.CityID,
              Detail: data.ResponseVM.CityName
            };
            context.Local = data.ResponseVM.Local;
            context.Street = data.ResponseVM.Street;
            context.Num = data.ResponseVM.Number;
          }
        );
      
    },
    addCaja() {
      let self = this;
      if (self.CajaName == undefined || self.CajaName == null || self.CajaName == "") {
        notificationHelpers.showError(
          "Alerta!",
          "Debe seleccionar un nombre para la caja",
          self
        );
        return;
      }
      self.Cajas.push({ Name: self.CajaName });
      self.CajaName = "";
    },
    itemClicked(item) {
      //-- Navegamos a gestion de sucursal
      let self = this;
      self.Cajas.splice(this.Cajas.indexOf(item), 1);
    },
    addUpdate() {
      let self = this;

      if (self.Name == "" || self.Name == null || self.Name == undefined) {
        notificationHelpers.showError(
          "Alerta!",
          "Debe ingresar un nombre",
          self
        );
        return;
      } else if (self.City == undefined || self.City == null) {
        notificationHelpers.showError(
          "Alerta!",
          "Debe seleccionar una localidad",
          self
        );
        return;
      } else if (
        self.Street == "" ||
        self.Street == null ||
        self.Street == undefined
      ) {
        notificationHelpers.showError(
          "Alerta!",
          "Debe ingresar una calle para la direccion",
          self
        );
        return;
      } else if (self.Num == "" || self.Num == null || self.Num == undefined) {
        notificationHelpers.showError(
          "Alerta!",
          "Debe ingresar un numero para la direccion",
          self
        );
        return;
      }

      axiosHelpers.axiosPost(
        "Commerce/CreateBranchOffice",
        this.getDataToRequest(),
        this,
        function(response) {
          var hasError = axiosHelpers.getResponseHasErrors(response);

          if (!hasError) {
            notificationHelpers.showSuccess(
              "Exito",
              "Se creo correctamente la sucursal.",
              self
            );
            self.$router.push({ name: "sucursales" });
          }
        }
      );
    },

    getDataToRequest() {
      return {
        EntityID: this.EntityID,
        Name: this.Name,
        ProvinceZipCodeID: this.SeModificaCP ? this.ProvinceZipCodeID : this.OriginalProvinceZipCodeID,
        CityID: this.City.ID,
        Street: this.Street,
        Number: this.Num,
        Local: this.Local,
        CashBoxes: this.Cajas
      };
    }
  },
  watch:{
  City: function(newValue, oldValue) {
      if(newValue != null){
        this.validateProvince();
      }
    },
  CodigoPostal: function(newValue, oldValue) {
    if(oldValue != '' || this.EntityID == 0){
      this.SeModificaCP = true;
    }
  }
  },
  mounted() {
    if(this.isUpdate()){
      this.getData();
    }
  }
};
</script>
<style></style>
